<template>
  <div class="contract">
    <signboard v-if="ISshow" :signboardName="signboardName"></signboard>
    <div v-if="ISshow" class="list">
      <div class="row">
        <div>合同序号</div>
        <div>{{info.name}}</div>
      </div>
      <div class="row">
        <div>合同类型</div>
        <div>{{info.type}}</div>
      </div>
      <div class="row"> 
        <div>有效期</div>
        <div>{{info.date}}</div>
      </div>
      <div class="row">
        <div>甲方名称</div>
        <div>{{info.contractSubject}}</div>
      </div>
      <div class="row">
        <div>乙方名称</div>
        <div>{{info.custCompany}}</div>
      </div>
      <div class="row">
        <div>月结账户</div>
        <div>{{info.billType}}</div>
      </div>
      <div class="row">
        <div>结算方式</div>
        <div>{{info.payWay}}</div>
      </div>
      <div class="row">
        <div>是否有效</div>
        <div>{{info.effect}}</div>
      </div>
    </div>
    <noContent style="padding-top: 100px;" v-if="!ISshow" img = '1' explain="抱歉，暂未查询到您的合同!"></noContent>
  </div>
</template>

<script>
import signboard from "@/components/signboard";
import API from "../../../api/setTing";
import noContent from "@/components/noContent";
const api = new API();
export default {
  components:{noContent,signboard},  
   data() {
    return {
      ISshow:true,
      signboardName:'生效合同',
      info:{type:'',name:'',date:'',custCompany:'',payWay:'',billType:'',effect:'',contractSubject:''},
    }
   },
  methods: {
    //查询客户基础信息
    async queryCustomerContracts() {
      let parme = {
        "msg": ""
      }
      let res = await api.queryCustomerContracts(parme);
      console.info(res.data);
      if(res.data[0]){
        this.info.type = res.data[0].contractType;
        this.info.name = res.data[0].contractNum;
        const begin = this.dateFormatter(res.data[0].contractBeginDate);
        const end = this.dateFormatter(res.data[0].contractendDate);
        this.info.date =  begin+"-"+ end;
        this.info.custCompany = res.data[0].custCompany;
        this.info.contractSubject = res.data[0].contractSubject;
        this.info.payWay = res.data[0].payWay;
        this.info.billType = res.data[0].billType;
        this.info.effect = "是";
      }else {
        this.ISshow = false
        // this.$message("抱歉，暂未查询到您的合同!");
      }

    },
    dateFormatter(str){
      var d = new Date(str);
      var year = d.getFullYear();
      var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
      var day = d.getDate()-1<10 ? '0'+(d.getDate()) : d.getDate();
      return [year, month, day].join('/');
    }
  },
  mounted() {
    this.queryCustomerContracts()
  },

}
</script>

<style lang='less' scoped>
.contract {
  width: 100%;
  height: 100%;
  .list {
    margin-left: 32px;
    width: 433px;
    border: 1px solid #EAEAEA;
    border-bottom: 0px;
    font-size: 14px;
    color: #323233;
    .row {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #EAEAEA;
      line-height: 44px;
    }
    .row>div:first-child {
      width: 100px;
      background: #F6F6F6;
      text-align:right;
      padding-right: 12px;
    }
    .row>div:last-child {
      padding-left: 12px;
    }
    
  }
}
</style>